exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.member_check .el-transfer-panel {\n    border: 1px solid #e6ebf5;\n    border-radius: 4px;\n    overflow: hidden;\n    background: #fff;\n    display: inline-block;\n    vertical-align: middle;\n    width: 500px;\n    max-height: 100%;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    position: relative;\n}\n", ""]);

// exports
